import pxToRem from "./pxToRem";
import borders from "./borders";
import colors from "theme/theme-light/colors";

const globals = {
  html: {
    scrollBehavior: "smooth",
    fontSize: "16px", // Mặc định
    "@media screen and (max-width: 1600px)": {
      fontSize: "15px",
    },
    "@media screen and (max-width: 1400px)": {
      fontSize: "14px",
    },
    "@media screen and (max-width: 1200px)": {
      fontSize: "13px",
    },
    "@media screen and (min-width: 2559px)": {
      // 2K trở lên
      fontSize: "18px",
    },
    "@media screen and (min-width: 3841px)": {
      // 4K trở lên
      fontSize: "20px",
    },
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    transition: "color 150ms ease-in !important",
  },

  body: {
    lineHeight: "normal",
    "::-webkit-scrollbar": {
      display: "block",
      width: "8px",
      height: "8px",
      borderRadius: "4px",
      backgroundColor: "transparent",
    },

    "::-webkit-scrollbar-corner": {
      backgroundColor: "transparent",
    },

    /* Track */
    "::-webkit-scrollbar-track": {
      background: "transparent",
    },

    /* background color */
    "::-webkit-scrollbar-thumb": {
      background: "#A0A3BD", // BA yêu cầu tạm thời để mã màu này
      // background: colors.stroke.strokeGrayOpacity_0_2,
      opacity: 0.2,
      borderRadius: borders.borderRadius.md_4,
    },

    div: {
      fontSize: pxToRem(14),
      "::-webkit-scrollbar": {
        display: "block",
        width: "6px",
        height: "8px",
        borderRadius: "4px",
        backgroundColor: "transparent",
        opacity: 0.12,
      },

      "::-webkit-scrollbar-corner": {
        display: "none",
      },

      /* Track */
      "::-webkit-scrollbar-track": {
        background: "transparent",
      },

      /* background color */
      "::-webkit-scrollbar-thumb": {
        // background: colors.background.bgSecondary,
        background: "#A0A3BD", // BA yêu cầu tạm thời để mã màu này
        opacity: 0.2,
        borderRadius: borders.borderRadius.md_4,
      },
    },
    span: {
      fontSize: pxToRem(14),
    },
    ".MuiPickersPopper-root": {
      ".MuiPickersMonth-monthButton.Mui-selected": {
        backgroundColor: colors.background.bgBrand,
      },
      ".MuiPickersYear-yearButton.Mui-selected": {
        backgroundColor: colors.background.bgBrand,
      },
    },
  },
};

export default globals;
